
















































































































import axios from 'axios'
import * as _ from 'lodash'
import dayjs from 'dayjs'

import ExtranetHeader from "@/views/extranet/v2/components/ExtranetHeader.vue";
import ExtranetUi from '@/views/iot-console/components/extranetui/ExtranetUi.vue';
import DeviceSetting from '@/views/extranet/v2/components/DeviceSetting.vue'

import {createExtranetVersionService} from "@/views/extranet/v2/ExtranetVersionService";
import { ExtranetData } from '@/views/iot-console/components/extranetui/Extranet';
import { generateDeviceDataList, generateGatewayData, generatePcData } from '@/views/extranet/v2/extranet.util';

import {ExtranetSocketV2} from "@/api/ExtranetSocketV2";
import {ExtranetServiceProxy} from "@/service-proxies/app-v2/iot-extranet.service-proxies"

import {
  DeviceConfigDto,
  ExtranetConfigServiceProxy,
  BeginExtranetDTO,
  CloseExtranetDTO,
} from "@/service-proxies/app-v2/iot-extranet.service-proxies";


const esp = new ExtranetServiceProxy()
const ecsp = new ExtranetConfigServiceProxy()

export default {
  name: "ConnectionConfig",
  components: { ExtranetHeader,DeviceSetting, ExtranetUi},
  provide: function(){
    return {
      extranet: this
    }
  },
  data() {
    return {
      extranetSocketConfig: null, // websocket握手包信息
      extranetLogList: [], // websocket连接日志
      versionService: createExtranetVersionService(),
      remoteConnect: undefined,
      connectCode: undefined,
      titleKey: '',
      workstationInfo: [],
      virtualLinkMsgList: [],
      comPortsList: [],
      extranetGatewayInfo: {},
      cardLoading: false,
      simpleToken: '',
      currentDevice: {},
      tabBarExtra: undefined,
      userVisibleStatus: 0,
      detailLoading: false,
      spinning: false, // 全局加载中
      expiryTime: undefined,
      expiryTimeType: 'B', // 到期类型
      initData: {},
      extranetSetting:{
        max: 999,
        editEnable: true,
        deleteEnable: true,
      }
      // tabList:[]
    }
  },
  props: {
    gateway: {
      type: Object,
      default: undefined
    }
  },
  created() {
    this.remoteConnect = new ExtranetSocketV2();
    this.remoteConnect.connect();
    this.initTitleKey()
  },
  mounted() {
    this.$nextTick(() => {
      this.initNewVersion();
      this.getDeviceListInfo()
    })
  },
  beforeDestroy() {
    this.remoteConnect.close();
    this.remoteConnect = undefined;
  },
  computed: {
    canConnect() {
      return this.currentDevice.userVisibleStatus == 1 ;
    },
    deviceConnecting() {
      return this.currentDevice.userVisibleStatus == 2 ;
    },
    deviceReady() {
      return this.currentDevice.userVisibleStatus == 1 ;
    },
    deviceNotReady() {
      return this.currentDevice.userVisibleStatus == 0 ;
    },
    isWorking(): boolean {
      return this.extranetSocketConfig &&
          this.extranetSocketConfig.diagnosising === 'Working';
    },
    gatewayCode() {
      return this.gateway.code
    },
    tabList() {
      if (this.workstationInfo && this.workstationInfo.length > 0) {
        return this.workstationInfo.map((item) => ({
          key: item.code,
          tab: item.name,
          record: item
        }))
      }
      return [];
    },
  },
  watch: {
    remoteConnect: {
      handler(ExtranetSocketV2) {
        this.versionService.currentVersion = ExtranetSocketV2.version;
        this.versionService.checkVersion()
      },
      deep: true,
    },
    tabList() {
      this.initTitleKey()
    },
    gateway() {
      this.$nextTick(() => {
        this.getDeviceListInfo()
      })
    }
  },
  methods: {
    // 清空诊断日志
    clearLogs() {
      this.extranetLogList = []
    },

    startExtranetCode() {

      if(this.versionService.needUpdate){
        this.$confirm({
            content: `发现新版本:${this.versionService.newVersion},点击确认下载!`,
            onOk:()=>{
              window.open(this.versionService.downloadUrl);
            },
            cancelText: '取消',
          });
        return;
      }

      const input = new BeginExtranetDTO();
      input.expireTime = dayjs(this.expiryTime).format('YYYY-MM-DD HH:mm:ss');
      input.workStationIds = [this.currentDevice.id];

      esp.beginExtranet(new BeginExtranetDTO(input)).then((res) => {
        if (res) {
          const beginParam = {
            extranetCode: res.extranetCode,
            sessionId: res.sessionId,
            gatewayIdList : [this.currentDevice.gatewayId]
          }
          this.beginConnect(beginParam);
        }
        this.changeConnectStates()
      })
    },
    changeConnectStates(){
      // this.$emit("refreshDeviceState")
    },
    showDrawer() {
      this.$refs.deviceSetting?.showDrawer();
    },
    disabledStartDate(expiryTime) {
      if (!expiryTime) {
        return false
      }
      return expiryTime.valueOf() < new Date().valueOf()
    },
    beginConnect(res) {
      this.loading();
      this.connectCode = res.extranetCode;

      this.remoteConnect.startRemoteConnection(res.extranetCode)
          .then(res => {
            this.remoteConnect.refreshServerInfo();
            this.refreshDevice();
          }).finally(() => {
        this.unloading();
        this.changeCurrentDevice(this.currentDevice);
      });

    },
    stopDiagnose() {
      
      this.stopConnect(this.currentDevice.extranetCode);
      return esp.closeExtranet(new CloseExtranetDTO({
        gatewayCode: this.currentDevice.gatewayCode,
        sessionId: this.currentDevice.sessionId,
        gatewayId: this.currentDevice.gatewayId
      })).then((res) => {
        // todo 重新刷状态
        this.refreshDevice()
      })
    },
    stopConnect(connectCode) {
      this.remoteConnect.stopRemoteConnection(connectCode)
          .then(res => {
            setTimeout(this.remoteConnect.refreshServerInfo, 2000)
          });
    },
    async initNewVersion() {
      const versionUrl = (window as any).masterlink?.extranetVersionUrl + `?t=${new Date().getTime()}`;
      if (!versionUrl) {
        console.warn('远程连接版本地址为:', versionUrl, ',停止版本判断');
        return;
      }
      const newVersionRequest = await axios.get(`${versionUrl}?v=${new Date().getTime()}`)
      this.versionService.newVersion = newVersionRequest.data.version
      this.versionService.downloadUrl = newVersionRequest.data.downloadUrl
      this.versionService.checkVersion()
    },
    onTabChange(value) {
      this.titleKey = value;
      this.setCurrentDevice(this.titleKey)
    },
    initTitleKey() {
      if (this.tabList && this.tabList.length > 0) {
        this.titleKey = this.tabList[0].key
        this.setCurrentDevice(this.titleKey)
      } else {
        this.titleKey = ''
        this.currentDevice = {}
      }
    },
    chooseTimeType(value) {
      if (value === 'B') {
        // 有期限，选择具体日期时间
        this.expiryTimeType = 'B'
      } else {
        // 无期限
        this.expiryTime = null
      }
    },
    changeTimeType(time) {
      this.expiryTime = dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    // // 切换选中的设备
    async changeCurrentDevice(data) {
      this.detailLoading = true;
      this.useDevice = data;
      try {
        this.currentDevice = await esp.getDeviceDetails(data.id);
      } finally {
        this.detailLoading = false;
      }
    },
    refreshDevice() {
      esp.getDeviceDetails(this.currentDevice.id).then((res) => {
        if (res) {
          this.currentDevice = res
          this.refreshExtranetConfig(this.currentDevice);
        }
      })
    },
    setCurrentDevice(value) {
      
      let obj = this.tabList.find((item) => item.key === value)
      
      if (obj) {
        this.expiryTimeType = 'B'
        if(obj.expiredDate){
          this.changeTimeType(obj.expiredDate)
        }else{
          this.expiryTime = dayjs()
            .add(1, 'day')
            .format('YYYY-MM-DD 23:59:59')
        }
        
        this.currentDevice = obj.record
        this.refreshExtranetConfig(obj.record);
      }
    },
    onSettingClosed(){
      this.refreshExtranetConfig(this.currentDevice)  ;
    },
    refreshExtranetConfig(record){
      console.log('refreshExtranetConfig:', record);
      const deviceId = record.id;
      const gatewayCode = record.gatewayCode;
      
      ecsp.getExtranetConfig(deviceId, gatewayCode)
        .then((res:DeviceConfigDto)=>{
          const ui = this.$refs.extranetuiEditer;
          const data = new ExtranetData();
          data.pc=generatePcData(res);
          data.gateway=generateGatewayData(res);
          data.deviceDataList=generateDeviceDataList(res);
          ui?.updateExtranetData(data);
        })
        .finally(()=>{
          this.editerLoading = false;
        });
    },
    getDeviceListInfo() {
      if (!this.gateway.id) {
        return
      }
      this.cardLoading = true
      esp.getDeviceListByGateway(this.gateway.id).then((res) => {
        if (res) {
          this.workstationInfo = res
        }
      }).finally(()=>{
        this.cardLoading = false
      })
    },
    // 得到生成诊断码接口返回的诊断码和短token，短token用于websocket开启诊断服务
    changeCode(data) {
      const {code, simpleToken} = data
      this.currentDevice.extranetCode = code
      this.simpleToken = simpleToken
    },
    /* 改变连接状态后调用此接口刷新数据 */
    getDeviceInfo(showCode) {
      esp.getDeviceDetails(this.currentDevice.id).then((res) => {
        if (res) {
          this.currentDevice = res
          this.$refs.deviceTab.isfoldCode = !showCode
          this.deviceList.map((item, index) => {
            if (item.id === this.currentDevice.id) {
              this.deviceList[index] = res
            }
          })
          this.deviceList = _.cloneDeep(this.deviceList)
        }
      })
    },
    loading(){
      this.spinning = true;
    },
    unloading(){
      this.spinning=false;
    },
  }
}
